/**
 * Menu Types Service
 * Handles all menu type-related API calls (Restaurant, Drinks, etc.)
 */

import { apiService, ApiResponse } from './api.service';

/** Menu Type Interface */
export interface MenuType {
  id: string;
  tenantId: string;
  name: string;
  description?: string;
  icon?: string;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  _count?: {
    categories: number;
  };
}

/** Create Menu Type DTO */
export interface CreateMenuTypeDto {
  name: string;
  description?: string;
  icon?: string;
  sortOrder?: number;
  isActive?: boolean;
  tenantId: string;
}

/** Update Menu Type DTO */
export interface UpdateMenuTypeDto {
  name?: string;
  description?: string;
  icon?: string;
  sortOrder?: number;
  isActive?: boolean;
}

class MenuTypesService {
  /** Get all menu types */
  async getMenuTypes(tenantId?: string): Promise<ApiResponse<MenuType[]>> {
    const params = tenantId ? `?tenantId=${tenantId}` : '';
    return apiService.get<MenuType[]>(`/menu-types${params}`);
  }

  /** Get single menu type */
  async getMenuTypeById(id: string): Promise<ApiResponse<MenuType>> {
    return apiService.get<MenuType>(`/menu-types/${id}`);
  }

  /** Create new menu type */
  async createMenuType(data: CreateMenuTypeDto): Promise<ApiResponse<MenuType>> {
    return apiService.post<MenuType>('/menu-types', data);
  }

  /** Update menu type */
  async updateMenuType(id: string, data: UpdateMenuTypeDto): Promise<ApiResponse<MenuType>> {
    return apiService.patch<MenuType>(`/menu-types/${id}`, data);
  }

  /** Delete menu type */
  async deleteMenuType(id: string): Promise<ApiResponse<void>> {
    return apiService.delete(`/menu-types/${id}`);
  }
}

export const menuTypesService = new MenuTypesService();
